import { z } from 'zod';

import {
  cnpjSchema,
  cpfSchema,
  emailListSchema,
  emailSchema,
  telefoneBrSchema,
  textoCurtoSchema,
} from './common.js';

export const enderecoSchema = z.object({
  rua: textoCurtoSchema,
  numero: z.string().min(1).max(20),
  complemento: z.string().max(100).optional(),
  bairro: textoCurtoSchema,
  cidade: textoCurtoSchema,
  uf: z
    .string()
    .length(2)
    .regex(/^[A-Z]{2}$/, 'UF inválida'),
  cep: z.string().regex(/^\d{8}$/, 'CEP deve ter 8 dígitos'),
});

export const clienteSchema = z.object({
  empresa: textoCurtoSchema,
  cnpj: cnpjSchema.optional(),
  cpf: cpfSchema.optional(),
  responsavel: textoCurtoSchema,
  cargo: textoCurtoSchema.optional(),
  /** 1 ou mais e-mails separados por vírgula/ponto-e-vírgula. UI mostra hint. */
  email: emailListSchema,
  telefone: telefoneBrSchema.optional(),
  endereco: enderecoSchema.optional(),
  segmento: textoCurtoSchema.optional(),
});

export const vendedorSchema = z.object({
  email: emailSchema,
  nome: textoCurtoSchema,
});
